import { useMutation, useQuery } from '@tanstack/react-query';
import fitStudioRequest from '../utils/request';

const fitSurveyServices = {
  useQueryGetLegacySurveyLists({ take, page, membeyType }, onSuccess) {
    return useQuery(
      ['get-legacy-survey', { take, page, membeyType }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              membeyType: queryKey[1].membeyType,
            },
          });

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      }
    );
  },
  useQueryGetLegacySurveyById({ surveyId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey-by-id', { surveyId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey/${queryKey[1].surveyId}`
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!surveyId,
        refetchOnWindowFocus: false,
      }
    );
  },
  useMutationCreateLegacySurvey(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(`/legacy-survey`, data);

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationUpdateLegacySurvey(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey/${data.id}`,
            data.data
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationUpdateLegacySurveyDisplay(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey/${data.id}/display`,
            {
              display: data.display,
            }
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationDeleteLegacySurvey(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey/${data.id}`
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useQueryGetLegacySurveyQuestionLists({ take, page, surveyId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey-question', { take, page, surveyId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey-question`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              surveyId: queryKey[1].surveyId,
            },
          });

          return res.data;
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
      }
    );
  },
  useQueryGetLegacySurveyQuestionById({ questionId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey-question-by-id', { questionId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey-question/${queryKey[1].questionId}`
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!questionId,
        refetchOnWindowFocus: false,
      }
    );
  },
  useQueryGetLegacySurveyQuestionAnswer({ questionId }, onSuccess) {
    return useQuery(
      ['get-legacy-survey-question-answer', { questionId }],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey-question/${queryKey[1].questionId}`
          );

          if (res.status === 200) {
            return res.data.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!questionId,
        refetchOnWindowFocus: false,
      }
    );
  },
  useMutationCreateLegacySurveyQuestion(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.post(
            `/legacy-survey-question`,
            data
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationUpdateLegacySurveyQuestion(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey-question/${data.id}`,
            data.data
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationUpdateLegacySurveyQuestionDisplay(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.patch(
            `/legacy-survey-question/${data.id}/display`,
            {
              display: data.display,
            }
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationDeleteLegacySurveyQuestion(onSuccess) {
    return useMutation(
      async (data) => {
        try {
          const res = await fitStudioRequest.delete(
            `/legacy-survey-question/${data.id}`
          );

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      {
        onSuccess,
      }
    );
  },
  useMutationDownloadLegacySurveyQuestionByIdExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey-question/download-excel/by-filter/${data.id}`,
            {
              responseType: 'blob',
            }
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'answer.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
  useQueryGetLegacySurveyUserAnswers(
    { take, page, answerId, memberType, searchText, startDate, endDate },
    onSuccess
  ) {
    return useQuery(
      [
        'get-legacy-survey-question-by-id',
        { take, page, answerId, memberType, searchText, startDate, endDate },
      ],
      async ({ queryKey }) => {
        try {
          const res = await fitStudioRequest.get(`/legacy-survey-user-answer`, {
            params: {
              take: queryKey[1].take,
              page: queryKey[1].page,
              answerId: queryKey[1].answerId,
              ...(queryKey[1].memberType && {
                memberType: queryKey[1].memberType,
              }),
              ...(queryKey[1].searchText && {
                searchText: queryKey[1].searchText,
              }),
              ...(queryKey[1].startDate && {
                startDate: queryKey[1].startDate,
              }),
              ...(queryKey[1].endDate && {
                endDate: queryKey[1].endDate,
              }),
            },
          });

          if (res.status === 200) {
            return res.data;
          }
        } catch (error) {
          throw new Error(error.response.data.message);
        }
      },
      {
        onSuccess,
        enabled: !!answerId,
        refetchOnWindowFocus: false,
      }
    );
  },
  useMutationDownloadLegacyUserAnswersExcel(onSuccess) {
    return useMutation({
      mutationFn: async (data) => {
        try {
          const res = await fitStudioRequest.get(
            `/legacy-survey-user-answer/download-excel/by-filter`,
            {
              params: {
                take: data.take,
                page: data.page,
                answerId: data.answerId,
                ...(data.memberType && {
                  memberType: data.memberType,
                }),
                ...(data.searchText && {
                  searchText: data.searchText,
                }),
                ...(data.startDate && {
                  startDate: data.startDate,
                }),
                ...(data.endDate && {
                  endDate: data.endDate,
                }),
              },
              responseType: 'blob',
            }
          );

          if (res.status === 200) {
            // create file link in browser's memory
            const href = URL.createObjectURL(res.data);

            // create "a" HTLM element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', 'answer.xlsx'); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
          }

          return res.data.data;
        } catch (error) {
          throw error.response.data.message;
        }
      },
      onSuccess,
    });
  },
};

export default fitSurveyServices;
